import { render, staticRenderFns } from "./pic_force.vue?vue&type=template&id=052b6972&scoped=true"
import script from "./pic_force.vue?vue&type=script&lang=js"
export * from "./pic_force.vue?vue&type=script&lang=js"
import style0 from "./pic_force.vue?vue&type=style&index=0&id=052b6972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b6972",
  null
  
)

export default component.exports